import { createApi } from '@reduxjs/toolkit/query/react';
import { axiosBaseQuery } from './axiosBaseQuery';

// ── Auth ────────────────────────────────────────────────────────────

export const authApi = createApi({
  reducerPath: 'authApi',
  baseQuery: axiosBaseQuery(),
  tagTypes: ['Auth', 'Session'],
  endpoints: () => ({}),
});

// ── Dashboard ───────────────────────────────────────────────────────
// Dashboard aggregates data from integrations, events, tickets, billing.
// When any of those mutate, dashboard tags should be invalidated.

export const dashboardApi = createApi({
  reducerPath: 'dashboardApi',
  baseQuery: axiosBaseQuery(),
  tagTypes: [
    'DashboardStats',
    'DashboardIntegrations',
    'DashboardEvents',
    'DashboardTickets',
    'DashboardBilling',
    'DashboardQuickActions',
  ],
  endpoints: () => ({}),
});

// ── Integrations ────────────────────────────────────────────────────
// Mutations here should also invalidate DashboardIntegrations + DashboardStats

export const integrationsApi = createApi({
  reducerPath: 'integrationsApi',
  baseQuery: axiosBaseQuery(),
  tagTypes: ['Integration', 'IntegrationList', 'IntegrationDetail'],
  endpoints: () => ({}),
});

// ── Event Logs ──────────────────────────────────────────────────────
// Read-only. New events come from integration syncs.

export const eventLogsApi = createApi({
  reducerPath: 'eventLogsApi',
  baseQuery: axiosBaseQuery(),
  tagTypes: ['EventLog', 'EventLogList'],
  endpoints: () => ({}),
});

// ── Support Tickets ─────────────────────────────────────────────────
// Create/update ticket → invalidate TicketList + DashboardTickets

export const supportTicketsApi = createApi({
  reducerPath: 'supportTicketsApi',
  baseQuery: axiosBaseQuery(),
  tagTypes: ['Ticket', 'TicketList', 'TicketDetail'],
  endpoints: () => ({}),
});

// ── Users ───────────────────────────────────────────────────────────
// Invite/deactivate → invalidate UserList + DashboardStats (totalUsers)

export const usersApi = createApi({
  reducerPath: 'usersApi',
  baseQuery: axiosBaseQuery(),
  tagTypes: ['User', 'UserList', 'UserDetail'],
  endpoints: () => ({}),
});

// ── Profile ─────────────────────────────────────────────────────────

export const profileApi = createApi({
  reducerPath: 'profileApi',
  baseQuery: axiosBaseQuery(),
  tagTypes: ['Profile'],
  endpoints: () => ({}),
});

// ── Clients ────────────────────────────────────────────────────────

export const clientsApi = createApi({
  reducerPath: 'clientsApi',
  baseQuery: axiosBaseQuery(),
  tagTypes: ['Client', 'ClientList', 'ClientDetail'],
  endpoints: () => ({}),
});

// ── Settings ───────────────────────────────────────────────────────

export const settingsApi = createApi({
  reducerPath: 'settingsApi',
  baseQuery: axiosBaseQuery(),
  tagTypes: ['Settings'],
  endpoints: () => ({}),
});

// ── Subscription Plans ─────────────────────────────────────────────

export const subscriptionPlansApi = createApi({
  reducerPath: 'subscriptionPlansApi',
  baseQuery: axiosBaseQuery(),
  tagTypes: [
    'PlanList',
    'PlanDetail',
    'SubscriptionList',
    'SubscriptionDetail',
    'BillingPreview',
    'InvoiceList',
    'PaymentList',
    'BillingOverview',
  ],
  endpoints: () => ({}),
});
